import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WeekdaySchedule } from '@mode/shared/schedules/contract';
import { TimeWithTimeZonePipe } from '../time-with-time-zone.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TimeWithTimeZonePipe],
  selector: 'mode-schedule-list-item',
  standalone: true,
  styleUrls: ['./schedule-list-item.component.scss'],
  templateUrl: './schedule-list-item.component.html',
})
export class ScheduleListItemComponent {
  @Input() schedule: WeekdaySchedule = { hour: 0, minute: 0, timeZone: 'UTC', frequency: 'weekday' };
}
